import type { AnyID } from '@types'
import { create } from 'zustand'
import type { SnapCandidate, SnapPreviewState } from './types'

type SnapDebugStore = SnapPreviewState & {
  enabled: boolean
  setEnabled: (enabled: boolean) => void
  setPreview: (partial: Partial<SnapPreviewState>) => void
  clear: () => void
}

const empty: SnapPreviewState = {
  dragId: null,
  dragPosition: null,
  candidates: [],
  best: null,
  updatedAt: 0,
}

export const useSnapDebugStore = create<SnapDebugStore>((set) => ({
  enabled: false,
  ...empty,
  setEnabled: (enabled) => set({ enabled }),
  setPreview: (partial) =>
    set((s) => ({
      ...s,
      ...partial,
      updatedAt: Date.now(),
    })),
  clear: () => set({ ...empty, updatedAt: Date.now() }),
}))

export function publishSnapPreview(
  dragId: AnyID | null,
  dragPosition: SnapPreviewState['dragPosition'],
  candidates: SnapCandidate[],
  best: SnapCandidate | null,
) {
  const store = useSnapDebugStore.getState()
  if (!store.enabled) return
  store.setPreview({ dragId, dragPosition, candidates, best })
}

export function enableModularSnapDebug(): void {
  if (typeof window === 'undefined') return
  ;(window as Window & { __MODULAR_SNAP_DEBUG__?: boolean }).__MODULAR_SNAP_DEBUG__ = true
  useSnapDebugStore.getState().setEnabled(true)
  console.warn('[ModularSnap] Debug activo. Desactivar: window.__MODULAR_SNAP_DEBUG__ = false')
}

if (typeof window !== 'undefined') {
  ;(window as Window & { __enableModularSnapDebug__?: () => void }).__enableModularSnapDebug__ =
    enableModularSnapDebug
}
